module.exports = __webpack_public_path__ + "static/media/Spediamopro_logo.4bc28fa9.svg";